import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-pipeline',
  imports: [SharedModule],
  templateUrl: './delete-pipeline.component.html',
  styleUrl: './delete-pipeline.component.scss'
})
export class DeletePipelineComponent {
  @Input() editPipelineData: any = null;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  loading: boolean = false;

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  onDelete(): void {
    if (!this.editPipelineData?.id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Pipeline ID not found'
      });
      return;
    }

    this.loading = true;

    this.api.deletePipeline(this.editPipelineData.id).subscribe(
      (response: any) => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message || 'Pipeline deleted successfully'
        });
        this.reload.emit();
        this.onClose();
      },
      (error: any) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error?.message || 'Failed to delete pipeline. Please try again later.'
        });
      }
    );
  }

  onClose(): void {
    this.closeDialog.emit();
  }
}
